var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClosetask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_211650_close_circled_icon",
    "data-name": "211650_close_circled_icon",
    transform: "translate(-32 -33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M43,33A11,11,0,1,0,54,44,11,11,0,0,0,43,33Zm5.318,14.708a.386.386,0,0,1,.113.275.378.378,0,0,1-.113.275l-1.061,1.066a.382.382,0,0,1-.275.113.4.4,0,0,1-.275-.113L43,45.611l-3.7,3.717a.375.375,0,0,1-.275.113.4.4,0,0,1-.275-.113l-1.061-1.066a.386.386,0,0,1-.113-.275.378.378,0,0,1,.113-.275L41.4,43.98,37.677,40.3a.394.394,0,0,1,0-.555l1.061-1.066a.391.391,0,0,1,.55,0L43,42.345l3.717-3.668a.391.391,0,0,1,.55,0l1.061,1.066a.394.394,0,0,1,0,.555L44.606,43.98Z",
    transform: "translate(0 0)",
    fill: "#f34c5f"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosetask);
export default __webpack_public_path__ + "static/media/closetask.54f6d7871b49a9b689fd5e153de14f90.svg";
export { ForwardRef as ReactComponent };